// extracted by mini-css-extract-plugin
export default {"Wrapper":"LoadingSpinner_Wrapper__slLkz","LoadingCard":"LoadingSpinner_LoadingCard__cp7Vd"};